import { createContext, useContext, useEffect, useRef } from "react";

const Ctx = createContext(null);

export function UnsavedProvider({ children }) {
  const dirtyRef = useRef(null);
  const setDirty = (msg) => {
    dirtyRef.current = msg;
    if (msg) {
      // Push a sentinel history entry so browser Back triggers popstate before actually leaving.
      if (window.history.state?.__unsavedGuard !== true) {
        window.history.pushState({ __unsavedGuard: true }, "");
      }
    }
  };
  const confirmLeave = () => {
    if (!dirtyRef.current) return true;
    if (window.confirm(dirtyRef.current)) { dirtyRef.current = null; return true; }
    return false;
  };
  useEffect(() => {
    const onPop = () => {
      if (!dirtyRef.current) return;
      if (window.confirm(dirtyRef.current)) {
        dirtyRef.current = null; // proceed — user accepts losing changes
        window.history.back();
      } else {
        // Re-push the sentinel so Back is guarded again next time.
        window.history.pushState({ __unsavedGuard: true }, "");
      }
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return <Ctx.Provider value={{ setDirty, confirmLeave }}>{children}</Ctx.Provider>;
}

export const useUnsaved = () => useContext(Ctx);
